var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery, useMutation } from '@apollo/client/react';
import { useMount } from 'react-use';
import { FileSystemDocumentDownloadFormat } from 'shared/domains/apollo/generated/types';
import { useActiveDocument } from 'shared/domains/documents';
import { useAccount } from 'shared/domains/users';
import { LogoUrlDocument } from './LogoUrl.gql';
import { PdfUrlDocument } from './PdfUrl.gql';
const FORMAT = FileSystemDocumentDownloadFormat.Pdf;
export function usePdfUrl() {
    var _a, _b;
    const { id: documentId } = useActiveDocument();
    const { data: accountData } = useAccount();
    const [mutate, mutateState] = useMutation(PdfUrlDocument);
    const [query, queryState] = useLazyQuery(LogoUrlDocument);
    const url = (_b = (_a = mutateState.data) === null || _a === void 0 ? void 0 : _a.downloadFileSystemDocument.signed) === null || _b === void 0 ? void 0 : _b.url;
    const loading = mutateState.loading || queryState.loading;
    const error = Boolean(mutateState.error || queryState.error);
    const getLogoUrl = () => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        const { data } = yield query({ variables: { companyId: accountData.companyId } });
        const logoPath = (_c = data === null || data === void 0 ? void 0 : data.company) === null || _c === void 0 ? void 0 : _c.logoPath;
        const logoUploaded = (_d = data === null || data === void 0 ? void 0 : data.company) === null || _d === void 0 ? void 0 : _d.logoUploaded;
        const logoUrl = logoUploaded && logoPath ? `${process.env.CDN_URL}/${logoPath}` : undefined;
        return logoUrl;
    });
    const getPdf = () => __awaiter(this, void 0, void 0, function* () {
        var _e, _f;
        try {
            const logoUrl = yield getLogoUrl();
            const appUrl = (_f = (_e = process.env.RENDER_SERVICE_CSS_FILE_APP_URL) !== null && _e !== void 0 ? _e : process.env.APP_URL) !== null && _f !== void 0 ? _f : window.location.origin;
            const cssUrl = new URL('/public/pdf.css', appUrl).toString();
            return yield mutate({
                variables: {
                    input: {
                        documentId,
                        cssUrl,
                        logoUrl,
                        downloadFormat: FORMAT,
                    },
                },
            });
        }
        catch (_g) {
            return null;
        }
    });
    useMount(getPdf);
    return { url, loading, error };
}
